import { useCallback, useMemo } from 'react';
import { TreeNode } from 'Components/Primitives';
import { useCustomersEssentialsQueryWithParam } from 'hooks';
import { getCustomersTreeSelectOptions } from 'Components/Customers/CustomersTreeSelect/CustomersTreeSelectUtils';

export const useCustomersTreeNodes = (): {
  getCustomersTreeNodes(): Promise<TreeNode[]>;
} => {
  const { fetch } = useCustomersEssentialsQueryWithParam();

  const getCustomersTreeNodes = useCallback(async (): Promise<TreeNode[]> => {
    const customers = await fetch();
    return getCustomersTreeSelectOptions(customers.data);
  }, [fetch]);

  return useMemo(() => ({ getCustomersTreeNodes }), [getCustomersTreeNodes]);
};
